import { gql } from "apollo-boost";

export const GET_MANUFACTURING_ORDERS = (id_entity) => gql`
  query GET_MANUFACTURING_ORDERS {
    manufacturingOrders(id_entity: ${id_entity}) {
        id_manufacturing_order
        name
        created_date
        number_pieces
        id_article {
            id_article
            name
        }
    }
  }
`;
